<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">Dosarul achiziției publice</h1>

      <p>
        Dosarul achiziţiei publice trebuie să cuprindă toate documentele întocmite sau primite de autoritatea contractantă în cadrul procedurii de atribuire. Conform <strong>Art. 148</strong>, aceste documente includ, fără a se limita la:
      </p>

      <ul class="mt-4">
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Strategia de contractare</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Anunţul de intenţie și dovada transmiterii (dacă este cazul)</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Anunţul de participare și dovada transmiterii</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Erata (dacă este cazul)</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Documentaţia de atribuire / de concurs</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Decizia / ordinul de numire a comisiei de evaluare și a experților cooptați</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Declaraţiile de confidenţialitate şi imparţialitate</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Procesul-verbal al ședinței de deschidere a ofertelor</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Formularele de ofertă depuse</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>DUAE și documentele de calificare</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Solicitări și răspunsuri la clarificări</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Raportul intermediar privind selecția candidaților</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Procese-verbale de evaluare / negociere / dialog</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Raportul procedurii de atribuire și anexele sale</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Comunicarea rezultatului procedurii</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Contractul semnat și actele adiționale</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Contracte atribuite prin acord-cadru (dacă este cazul)</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Anunțul de atribuire și dovada transmiterii</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Contestații și decizii ale CNSC (dacă este cazul)</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Hotărâri judecătorești legate de procedură</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Documentul constatator privind îndeplinirea obligațiilor contractuale</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Decizia de anulare a procedurii (dacă e cazul)</li>
      </ul>

      <p class="mt-4">
        Toate aceste documente sunt obligatorii pentru o procedură de achiziție transparentă și conformă cu legislația în vigoare.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DosarulAchizitiei'
}
</script>
